export default "__VITE_ASSET__C42Wd7pF__"